import { render } from "./PayForm.vue?vue&type=template&id=7fa89020&scoped=true"
import script from "./PayForm.vue?vue&type=script&lang=js"
export * from "./PayForm.vue?vue&type=script&lang=js"

import "./PayForm.vue?vue&type=style&index=0&id=7fa89020&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fa89020"

export default script